import { PayloadAction } from "@reduxjs/toolkit";
import { SetCustomFilterAllValuesPayload } from "./request";

export function setCustomFilterAllValuesReducer(
  state,
  action: PayloadAction<SetCustomFilterAllValuesPayload>,
) {
  state.filters = state.filters.map((f) => {
    if (f.id === action.payload.filterGroupId) {
      return {
        ...f,
        filters: f.filters.map((ff) =>
          ff.id === action.payload.filterId
            ?  { ...ff, enabledValues: action.payload.values }
            : ff,
        ),
      };
    }
    return f;
  });
}
